var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWinImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "433px",
    height: "433px",
    viewBox: "0 0 433 433",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 413,
    height: 413,
    rx: 5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-3.6%",
    width: "107.3%",
    height: "107.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-8.0%",
    width: "116.0%",
    height: "116.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.114647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0.247826087 149.752174 0.247826087 149.752174 149.999565 0 149.999565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 0 149.75 0 149.75 149.751957 0 149.751957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 0.000194444444 58.3330741 0.000194444444 58.3330741 56.6362222 0 56.6362222"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Better-Luck",
    transform: "translate(-503.000000, -100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(513.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wrp",
    fill: "#F4D01E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.654861,86.4771614 C138.471076,86.3760797 137.563638,85.8775628 137.317825,85.7443187 C137.072013,85.6087773 136.869849,85.4066138 136.734308,85.1608013 C136.598767,84.9126916 136.107142,84.0029558 136.003763,83.8237655 C135.900384,83.6445751 135.712004,83.5297095 135.502948,83.5297095 C135.293893,83.5297095 135.105513,83.6445751 135.002134,83.8237655 C134.898755,84.0029558 134.404833,84.9126916 134.271589,85.1608013 C134.136048,85.4066138 133.933884,85.6087773 133.688072,85.7443187 C133.439962,85.8775628 132.534821,86.3760797 132.351036,86.4771614 C132.167251,86.5782432 132.05698,86.7689201 132.05698,86.9756782 C132.05698,87.1824363 132.167251,87.3731133 132.351036,87.474195 C132.534821,87.5752768 133.439962,88.0714963 133.688072,88.2070377 C133.933884,88.3425792 134.136048,88.5424453 134.271589,88.7905551 C134.404833,89.0363675 134.898755,89.9484006 135.002134,90.127591 C135.105513,90.3067813 135.293893,90.421647 135.502948,90.421647 C135.712004,90.421647 135.900384,90.3067813 136.003763,90.127591 C136.107142,89.9484006 136.598767,89.0363675 136.734308,88.7905551 C136.869849,88.5424453 137.072013,88.3425792 137.317825,88.2070377 C137.563638,88.0714963 138.471076,87.5752768 138.654861,87.474195 C138.838646,87.3731133 138.948917,87.1824363 138.948917,86.9756782 C138.948917,86.7689201 138.838646,86.5782432 138.654861,86.4771614",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-718"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    filter: "url(#filter-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.752174,75.1234783 C149.752174,116.475652 116.228261,149.999565 74.876087,149.999565 C33.5217391,149.999565 0,116.475652 0,75.1234783 C0,33.7713043 33.5217391,0.247391304 74.876087,0.247391304 C116.228261,0.247391304 149.752174,33.7713043 149.752174,75.1234783",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.722222,74.3055556 C134.722222,107.673473 107.673473,134.722222 74.3055556,134.722222 C40.9376381,134.722222 13.8888889,107.673473 13.8888889,74.3055556 C13.8888889,40.9376381 40.9376381,13.8888889 74.3055556,13.8888889 C107.673473,13.8888889 134.722222,40.9376381 134.722222,74.3055556",
    id: "Fill-4",
    fill: "#64BAFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.873913,6.86956522 C37.376087,6.86956522 6.86956522,37.376087 6.86956522,74.876087 C6.86956522,112.376087 37.376087,142.882609 74.873913,142.882609 C112.373913,142.882609 142.880435,112.376087 142.880435,74.876087 C142.880435,37.376087 112.373913,6.86956522 74.873913,6.86956522 M74.873913,149.752174 C33.5891304,149.752174 0,116.163043 0,74.876087 C0,33.5891304 33.5891304,0 74.873913,0 C116.16087,0 149.75,33.5891304 149.75,74.876087 C149.75,116.163043 116.16087,149.752174 74.873913,149.752174",
    id: "Fill-6",
    fill: "#64BAFF",
    mask: "url(#mask-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(46.666667, 46.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35381481,28.3767685 C6.54862963,27.1478796 3.4777037,23.8760278 3.4777037,19.33575 C3.52177778,15.1623241 3.62288889,10.9830648 3.58075926,6.81547222 C3.56909259,5.65334259 3.67798148,4.34343519 4.7402963,3.66482407 C5.44418519,3.21436111 8.09575926,4.0245463 8.09575926,4.0245463 C9.23066667,4.44519444 10.4381667,3.60519444 10.4381667,2.3944537 C10.4381667,1.66658333 9.98446296,1.01584259 9.30261111,0.763064815 C9.30261111,0.763064815 5.44937037,-0.830731481 2.8665,0.734546296 C1.02446296,1.85065741 0.0114074074,3.99149074 0.140388889,6.22047222 L-0.000259259259,19.3176019 C-0.000259259259,24.5948241 3.23659259,29.7903796 8.02316667,31.5909352 C9.61177778,32.1885278 10.579463,31.6635278 10.8322407,30.8494537 C11.0856667,30.0366759 10.623537,28.9341759 9.35381481,28.3767685 L9.35381481,28.3767685 Z M58.1937222,6.22047222 C58.3214074,3.99149074 57.3083519,1.85065741 55.466963,0.734546296 C52.8834444,-0.830731481 49.0315,0.763064815 49.0315,0.763064815 C48.349,1.01584259 47.8959444,1.66658333 47.8959444,2.3944537 C47.8959444,3.60519444 49.1027963,4.44519444 50.2383519,4.0245463 C50.2383519,4.0245463 52.8892778,3.21436111 53.5938148,3.66482407 C54.6561296,4.34343519 54.7650185,5.65334259 54.7527037,6.81547222 C54.7105741,10.9830648 54.811037,15.1623241 54.8557593,19.33575 C54.8557593,23.8760278 51.7854815,27.1478796 48.9796481,28.3767685 C47.7099259,28.9341759 47.2477963,30.0366759 47.5005741,30.8494537 C47.754,31.6635278 48.7223333,32.1885278 50.3102963,31.5909352 C55.0962222,29.7903796 58.3330741,24.5948241 58.3330741,19.3176019 L58.1937222,6.22047222 Z M41.839,53.937787 C39.3079815,53.8833426 33.6224259,54.33575 33.6224259,46.1801019 C33.6224259,39.2786204 24.7713148,39.2753796 24.7713148,46.2021389 C24.7713148,54.6876944 19.1531667,54.077787 16.5651111,54.0129722 C15.8229815,53.9935278 15.2078889,54.5813981 15.2078889,55.3235278 C15.2078889,56.0481574 15.7957593,56.6366759 16.5203889,56.6366759 L41.8124259,56.6366759 C42.5370556,56.6366759 43.1249259,56.0481574 43.1249259,55.3235278 L43.1249259,55.2496389 C43.1249259,54.5334352 42.5552037,53.9533426 41.839,53.937787 L41.839,53.937787 Z M42.9687222,0.000194444444 L15.3647407,0.000194444444 C13.7962222,0.000194444444 12.5245556,1.27186111 12.5245556,2.84102778 L12.5245556,19.532787 C12.5245556,31.6998241 20.8953889,37.8390833 29.2409444,37.8390833 C37.5372407,37.8390833 45.8095556,31.7730648 45.8095556,19.532787 L45.8095556,2.84102778 C45.8095556,1.27186111 44.5372407,0.000194444444 42.9687222,0.000194444444 L42.9687222,0.000194444444 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-10)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWinImage);
export default __webpack_public_path__ + "static/media/no-win-image.ab40325c3d62ead949d4e1b30b6f181e.svg";
export { ForwardRef as ReactComponent };